import React, { useState, useEffect } from 'react'
import { services } from '../../services'
import { ReactComponent as Left } from '../../assets/icons/inventory/Arrow_Left.svg'
import { ReactComponent as Right } from '../../assets/icons/inventory/Arrow_Right.svg'
const Close = require('../../assets/icons/modal/Close.svg')
const { api } = services


const InventoryInfowindow = ({ closeInfoWindow , asset}) => {
  const [invMapAsset, setInvMapAsset] = useState([])
  const [totalLength, setTotalLength] = useState('')
  const [count, setCount] = useState(1)
  const [arrIndex, setArrayIndex] = useState(0)

  useEffect(() => {
    api.getInventoryComponents(asset.Location_ID).then((response)=>{
      setInvMapAsset(response.data.inventoryMapReport)
      setTotalLength(response.data.TotalCount)
    })
  }, [asset.Location_ID])

  const previousPage = (e) => {
    e.stopPropagation()
    if (count > 1) {
      setCount(count - 1)
      setArrayIndex(arrIndex - 1)
    }
  }
  const NextPage = (e) => {
    e.stopPropagation()
    if (count < totalLength) {
      setCount(count + 1)
      setArrayIndex(arrIndex + 1)

    }
  }
  const data = invMapAsset
  return (
    <div className='invmap-card'>
      <div className="invmap-infoheader">
        <span className="invmap-count">
          {count}/{totalLength}
        </span>
        {totalLength > 1 ? <span className='invmap-pagination'>
          <Left onClick={e=>previousPage(e)} className='LeftArrow' />
          <Right onClick={e=>NextPage(e)} className='RightArrow' />
        </span> : ''}
        <span className="invmap-close">
          <img src={Close} alt='close-button' onClick={closeInfoWindow} className="mouse-pointer" />
        </span>
      </div>
      <div className='invmap-header'>
        <p className='invmap-row1'>
            Location ID
        </p>
        <p className='invmap-rowValue1'>
          {data[arrIndex] && data[arrIndex].Location_ID}
        </p>
      </div>
      <div className='invmap-header'>
        <p className='invmap-row'>
            Street Name
        </p>
        <p className='invmap-rowValue'>
          {data[arrIndex] && data[arrIndex].Street_Name}
        </p>
      </div>
      <div className={data[arrIndex] && data[arrIndex].Street_Name.length >= 18 ? 'invmap-headermore' : 'invmap-header'}>
        <p className='invmap-row'>
            Component Type:
        </p>
        <p className='invmap-rowValue'>
          {data[arrIndex] && data[arrIndex].ComponentType}
        </p>
      </div>
      <div className='invmap-header'>
        <p className='invmap-row'>
            Pole No
        </p>
        <p className='invmap-rowValue'>
          {data[arrIndex] && data[arrIndex].Pole_No}
        </p>
      </div>
      <div className='invmap-header'>
        <p className='invmap-row'>
            Pole Suffix
        </p>
        <p className='invmap-rowValue'>
          {data[arrIndex] && data[arrIndex].Pole_Suffix}
        </p>
      </div>
      <div className='invmap-header'>
        <p className='invmap-row'>
            Seq
        </p>
        <p className='invmap-rowValue'>
          {data[arrIndex] && data[arrIndex].Seq}
        </p>
      </div>
      <div className='invmap-header'>
        <p className='invmap-row'>
            Bill Code Title
        </p>
        <p className='invmap-rowValue'>
          {data[arrIndex] && data[arrIndex].BillCodeTitle}
        </p>
      </div>
      <div className={data[arrIndex] && data[arrIndex].BillCodeTitle.length >= 20 ? 'invmap-headermore' : 'invmap-header'}>
        <p className='invmap-row'>
            Light Status
        </p>
        <p className='invmap-rowValue'>
          {data[arrIndex] && data[arrIndex].LightStatus}
        </p>
      </div>
      <div className='invmap-header'>
        <p className='invmap-row'>
            Source Type
        </p>
        <p className='invmap-rowValue'>
          {data[arrIndex] && data[arrIndex].SourceType}
        </p>
      </div>
    </div>
  )
}
export default InventoryInfowindow